export function screenSize() {
  const width = window.innerWidth

  if (width <= 767) {
    // The lowest we support is 360, but lower values still fall in xs
    return "xs"
  } else if (width >= 768 && width <= 991) {
    return "sm"
  } else if (width >= 992 && width <= 1199) {
    return "md"
  } else if (width >= 1200) {
    // The largest we support is 1440, but greater values still fall in lg
    return "lg"
  }
}

export function deviceType() {
  if (screenSize() === "xs") {
    return "mobile"
  } else {
    return "desktop"
  }
}
